export default "__VITE_ASSET__7e5b9034__"